module.exports = __webpack_public_path__ + "media/images/map/school-71d0954c0a91e6344e1a66d9cfb55dd2.svg";